

































import { Component, Prop, Vue } from 'vue-property-decorator';
import IconBar from '@/components/containers/icon-bar.vue';
import { List } from '@/interfaces/list';
import { SearchItemTypes } from '@/util/enums/search-item-types';

@Component({
  components: {
    IconBar,
  },
})
export default class DropdownIconBar extends Vue {
  @Prop({ required: true }) objectId: number;
  @Prop({ required: true }) objectName: string;
  @Prop({ required: true }) type: Exclude<SearchItemTypes, SearchItemTypes.COMPANY>;
  @Prop({ default: 'sm' }) size: string;
  @Prop({ default: 'primary' }) variant: string;
  @Prop({ default: false }) rightAlign: boolean; // TODO

  get firstListWithObject(): List {
    if (this.isOnList) {
      return this.$vmx.list.listsWithObjectId(this.objectId, this.type)[0];
    }
    return null;
  }

  get isOnList(): boolean {
    return this.$vmx.list.isIdInList(this.objectId, this.type);
  }
}
